export function gotSameRecurrenceSettings(
  a: uui.domain.client.rm.Recurrence,
  b: uui.domain.client.rm.Recurrence,
) {
  if (a.recurrencePeriod.recurrenceType !== b.recurrencePeriod.recurrenceType) return false

  if (a.recurrenceEndType !== b.recurrenceEndType) return false

  if (a.recurrenceEndType === 'ON_DATE' && a.endDate !== b.endDate) return false

  if (a.recurrenceEndType === 'AFTER_NUMBER' && a.requiredRecurrences !== b.requiredRecurrences)
    return false

  return true
}
